export const STATUSCODES = {
  expired        : 401,
  forbidden      : 403,
  paymentRequired: 402,
  ssoRequired    : 410,
  timeout        : 504
};
